module.exports = __webpack_public_path__ + "assets/img/246201.aefce748.svg";